var map = {
	"./app": [
		96099,
		9
	],
	"./app.js": [
		96099,
		9
	],
	"./bootstrap": [
		10558,
		9
	],
	"./bootstrap.js": [
		10558,
		9
	],
	"./components/auth/AuthenticateSignatureComponent": [
		60446,
		9,
		446
	],
	"./components/auth/AuthenticateSignatureComponent.vue": [
		60446,
		9,
		446
	],
	"./components/auth/LoginComponent": [
		88549,
		9,
		8549
	],
	"./components/auth/LoginComponent.vue": [
		88549,
		9,
		8549
	],
	"./components/auth/MagicLoginComponent": [
		82480,
		9,
		2480
	],
	"./components/auth/MagicLoginComponent.vue": [
		82480,
		9,
		2480
	],
	"./components/auth/SocialLoginComponent": [
		43079,
		9,
		3079
	],
	"./components/auth/SocialLoginComponent.vue": [
		43079,
		9,
		3079
	],
	"./components/auth/TwoFactorAuthenticationComponent": [
		12246,
		9,
		2246
	],
	"./components/auth/TwoFactorAuthenticationComponent.vue": [
		12246,
		9,
		2246
	],
	"./components/auth/VerifyComponent": [
		82297,
		9,
		2297
	],
	"./components/auth/VerifyComponent.vue": [
		82297,
		9,
		2297
	],
	"./components/auth/passwords/EmailComponent": [
		2940,
		9,
		2940
	],
	"./components/auth/passwords/EmailComponent.vue": [
		2940,
		9,
		2940
	],
	"./components/auth/passwords/ResetComponent": [
		37324,
		9,
		7324
	],
	"./components/auth/passwords/ResetComponent.vue": [
		37324,
		9,
		7324
	],
	"./components/auth/passwords/SelectOtpChannelComponent": [
		20162,
		9,
		162
	],
	"./components/auth/passwords/SelectOtpChannelComponent.vue": [
		20162,
		9,
		162
	],
	"./components/auth/passwords/VerifyPasswordComponent": [
		70512,
		9,
		512
	],
	"./components/auth/passwords/VerifyPasswordComponent.vue": [
		70512,
		9,
		512
	],
	"./components/dashboard/ApprovalNoticeModal": [
		74109,
		9,
		4109
	],
	"./components/dashboard/ApprovalNoticeModal.vue": [
		74109,
		9,
		4109
	],
	"./components/dashboard/ChangeCurrencyComponent": [
		12416,
		9,
		2416
	],
	"./components/dashboard/ChangeCurrencyComponent.vue": [
		12416,
		9,
		2416
	],
	"./components/dashboard/DocumentsTableComponent": [
		562,
		9,
		562
	],
	"./components/dashboard/DocumentsTableComponent.vue": [
		562,
		9,
		562
	],
	"./components/dashboard/SalutationComponent": [
		50864,
		9,
		864
	],
	"./components/dashboard/SalutationComponent.vue": [
		50864,
		9,
		864
	],
	"./components/dashboard/UploadComponent": [
		89071,
		9,
		9071
	],
	"./components/dashboard/UploadComponent.vue": [
		89071,
		9,
		9071
	],
	"./components/dashboard/bank-account/BankAccountCardComponent": [
		37283,
		9,
		7283
	],
	"./components/dashboard/bank-account/BankAccountCardComponent.vue": [
		37283,
		9,
		7283
	],
	"./components/dashboard/bank-account/BankBranchSelectorComponent": [
		21273,
		9,
		1273
	],
	"./components/dashboard/bank-account/BankBranchSelectorComponent.vue": [
		21273,
		9,
		1273
	],
	"./components/dashboard/bank-account/BankSelectorComponent": [
		41376,
		9,
		1376
	],
	"./components/dashboard/bank-account/BankSelectorComponent.vue": [
		41376,
		9,
		1376
	],
	"./components/dashboard/bank-account/CreateBankAccountModal": [
		43529,
		9,
		3529
	],
	"./components/dashboard/bank-account/CreateBankAccountModal.vue": [
		43529,
		9,
		3529
	],
	"./components/dashboard/bank-account/UpdateBankAccountModal": [
		38456,
		9,
		8456
	],
	"./components/dashboard/bank-account/UpdateBankAccountModal.vue": [
		38456,
		9,
		8456
	],
	"./components/dashboard/charts/AllocationChartComponent": [
		44374,
		9,
		4374
	],
	"./components/dashboard/charts/AllocationChartComponent.vue": [
		44374,
		9,
		4374
	],
	"./components/dashboard/charts/OverallChartComponent": [
		13637,
		9,
		3637
	],
	"./components/dashboard/charts/OverallChartComponent.vue": [
		13637,
		9,
		3637
	],
	"./components/dashboard/charts/TradingStockPerformanceComponent": [
		11660,
		9,
		1660
	],
	"./components/dashboard/charts/TradingStockPerformanceComponent.vue": [
		11660,
		9,
		1660
	],
	"./components/dashboard/charts/YearPerformanceComponent": [
		93421,
		9,
		3421
	],
	"./components/dashboard/charts/YearPerformanceComponent.vue": [
		93421,
		9,
		3421
	],
	"./components/dashboard/charts/partials/OverallChartMobile": [
		90497,
		9,
		497
	],
	"./components/dashboard/charts/partials/OverallChartMobile.vue": [
		90497,
		9,
		497
	],
	"./components/dashboard/clients/BankAccountInformation": [
		67238,
		9,
		7238
	],
	"./components/dashboard/clients/BankAccountInformation.vue": [
		67238,
		9,
		7238
	],
	"./components/dashboard/clients/ChangeAccountTypeModal": [
		89157,
		9,
		9157
	],
	"./components/dashboard/clients/ChangeAccountTypeModal.vue": [
		89157,
		9,
		9157
	],
	"./components/dashboard/clients/ClientPortfolioInformation": [
		88007,
		9,
		8007
	],
	"./components/dashboard/clients/ClientPortfolioInformation.vue": [
		88007,
		9,
		8007
	],
	"./components/dashboard/clients/ConfirmationModal": [
		41947,
		9,
		1947
	],
	"./components/dashboard/clients/ConfirmationModal.vue": [
		41947,
		9,
		1947
	],
	"./components/dashboard/clients/EditClientModalComponent": [
		19591,
		9,
		9591
	],
	"./components/dashboard/clients/EditClientModalComponent.vue": [
		19591,
		9,
		9591
	],
	"./components/dashboard/clients/FinancialInformation": [
		46635,
		9,
		6635
	],
	"./components/dashboard/clients/FinancialInformation.vue": [
		46635,
		9,
		6635
	],
	"./components/dashboard/clients/IdentificationInformation": [
		35736,
		9,
		5736
	],
	"./components/dashboard/clients/IdentificationInformation.vue": [
		35736,
		9,
		5736
	],
	"./components/dashboard/clients/PersonalInformation": [
		27903,
		9,
		7903
	],
	"./components/dashboard/clients/PersonalInformation.vue": [
		27903,
		9,
		7903
	],
	"./components/dashboard/clients/ProfessionInformation": [
		49450,
		9,
		9450
	],
	"./components/dashboard/clients/ProfessionInformation.vue": [
		49450,
		9,
		9450
	],
	"./components/dashboard/clients/ResetPasswordModalComponent": [
		64448,
		9,
		4448
	],
	"./components/dashboard/clients/ResetPasswordModalComponent.vue": [
		64448,
		9,
		4448
	],
	"./components/dashboard/clients/RiskProfileInformation": [
		93787,
		9,
		3787
	],
	"./components/dashboard/clients/RiskProfileInformation.vue": [
		93787,
		9,
		3787
	],
	"./components/dashboard/clients/SubaccountInformation": [
		44478,
		9,
		4478
	],
	"./components/dashboard/clients/SubaccountInformation.vue": [
		44478,
		9,
		4478
	],
	"./components/dashboard/clients/UpdateOtpModalComponent": [
		91174,
		9,
		1174
	],
	"./components/dashboard/clients/UpdateOtpModalComponent.vue": [
		91174,
		9,
		1174
	],
	"./components/dashboard/clients/edit-client/EditBankAccountInformationFormComponent": [
		71105,
		9,
		1105
	],
	"./components/dashboard/clients/edit-client/EditBankAccountInformationFormComponent.vue": [
		71105,
		9,
		1105
	],
	"./components/dashboard/clients/edit-client/EditFinancialInformationFormComponent": [
		70432,
		9,
		432
	],
	"./components/dashboard/clients/edit-client/EditFinancialInformationFormComponent.vue": [
		70432,
		9,
		432
	],
	"./components/dashboard/clients/edit-client/EditIdentificationInformationFormComponent": [
		26205,
		9,
		6205
	],
	"./components/dashboard/clients/edit-client/EditIdentificationInformationFormComponent.vue": [
		26205,
		9,
		6205
	],
	"./components/dashboard/clients/edit-client/EditPersonalInformationFormComponent": [
		27130,
		9,
		7130
	],
	"./components/dashboard/clients/edit-client/EditPersonalInformationFormComponent.vue": [
		27130,
		9,
		7130
	],
	"./components/dashboard/clients/edit-client/EditProfessionInformationFormComponent": [
		15737,
		9,
		5737
	],
	"./components/dashboard/clients/edit-client/EditProfessionInformationFormComponent.vue": [
		15737,
		9,
		5737
	],
	"./components/dashboard/clients/edit-client/EditRiskProfileInformationFormComponent": [
		37871,
		9,
		7871
	],
	"./components/dashboard/clients/edit-client/EditRiskProfileInformationFormComponent.vue": [
		37871,
		9,
		7871
	],
	"./components/dashboard/clients/edit-client/UpdateIdInformationModal": [
		47202,
		9,
		7202
	],
	"./components/dashboard/clients/edit-client/UpdateIdInformationModal.vue": [
		47202,
		9,
		7202
	],
	"./components/dashboard/clients/edit-client/UpdateIdentificationInformationComponent": [
		73699,
		9,
		3699
	],
	"./components/dashboard/clients/edit-client/UpdateIdentificationInformationComponent.vue": [
		73699,
		9,
		3699
	],
	"./components/dashboard/holdings/HoldingsTableComponent": [
		1967,
		9,
		1967
	],
	"./components/dashboard/holdings/HoldingsTableComponent.vue": [
		1967,
		9,
		1967
	],
	"./components/dashboard/holdings/IclfHoldingsTableComponent": [
		29409,
		9,
		9409
	],
	"./components/dashboard/holdings/IclfHoldingsTableComponent.vue": [
		29409,
		9,
		9409
	],
	"./components/dashboard/messages/CommentsComponent": [
		97710,
		9,
		7710
	],
	"./components/dashboard/messages/CommentsComponent.vue": [
		97710,
		9,
		7710
	],
	"./components/dashboard/messages/ComposeNewMessage": [
		43417,
		9,
		3417
	],
	"./components/dashboard/messages/ComposeNewMessage.vue": [
		43417,
		9,
		3417
	],
	"./components/dashboard/messages/CustomerInboxList": [
		1566,
		9,
		1566
	],
	"./components/dashboard/messages/CustomerInboxList.vue": [
		1566,
		9,
		1566
	],
	"./components/dashboard/messages/InboxList": [
		77223,
		9,
		7223
	],
	"./components/dashboard/messages/InboxList.vue": [
		77223,
		9,
		7223
	],
	"./components/dashboard/messages/InboxListMessage": [
		43975,
		9,
		3975
	],
	"./components/dashboard/messages/InboxListMessage.vue": [
		43975,
		9,
		3975
	],
	"./components/dashboard/nav/CustomerAccountProfileNavComponent": [
		27033,
		9,
		7033
	],
	"./components/dashboard/nav/CustomerAccountProfileNavComponent.vue": [
		27033,
		9,
		7033
	],
	"./components/dashboard/nav/CustomerDashboardNavComponent": [
		83925,
		9,
		3925
	],
	"./components/dashboard/nav/CustomerDashboardNavComponent.vue": [
		83925,
		9,
		3925
	],
	"./components/dashboard/nav/CustomerMessagesNavComponent": [
		90671,
		9,
		671
	],
	"./components/dashboard/nav/CustomerMessagesNavComponent.vue": [
		90671,
		9,
		671
	],
	"./components/dashboard/nav/CustomerPortfolioDetailsNavComponent": [
		7042,
		9,
		7042
	],
	"./components/dashboard/nav/CustomerPortfolioDetailsNavComponent.vue": [
		7042,
		9,
		7042
	],
	"./components/dashboard/nav/CustomerPricesTrendNavComponent": [
		47881,
		9,
		7881
	],
	"./components/dashboard/nav/CustomerPricesTrendNavComponent.vue": [
		47881,
		9,
		7881
	],
	"./components/dashboard/nav/CustomerSettingsNavComponent": [
		17746,
		9,
		7746
	],
	"./components/dashboard/nav/CustomerSettingsNavComponent.vue": [
		17746,
		9,
		7746
	],
	"./components/dashboard/nav/CustomerStatementNavComponent": [
		1974,
		9,
		1974
	],
	"./components/dashboard/nav/CustomerStatementNavComponent.vue": [
		1974,
		9,
		1974
	],
	"./components/dashboard/nav/CustomerTradeNavComponent": [
		69732,
		9,
		9732
	],
	"./components/dashboard/nav/CustomerTradeNavComponent.vue": [
		69732,
		9,
		9732
	],
	"./components/dashboard/portfolio/AccountTransactionHistory": [
		5997,
		9,
		5997
	],
	"./components/dashboard/portfolio/AccountTransactionHistory.vue": [
		5997,
		9,
		5997
	],
	"./components/dashboard/portfolio/AddPortfolioComponent": [
		98863,
		9,
		8863
	],
	"./components/dashboard/portfolio/AddPortfolioComponent.vue": [
		98863,
		9,
		8863
	],
	"./components/dashboard/portfolio/AddPortfolioModal": [
		73781,
		9,
		3781
	],
	"./components/dashboard/portfolio/AddPortfolioModal.vue": [
		73781,
		9,
		3781
	],
	"./components/dashboard/portfolio/DeletePortfolioModal": [
		74969,
		9,
		4969
	],
	"./components/dashboard/portfolio/DeletePortfolioModal.vue": [
		74969,
		9,
		4969
	],
	"./components/dashboard/portfolio/EditPortfolioModal": [
		70354,
		9,
		354
	],
	"./components/dashboard/portfolio/EditPortfolioModal.vue": [
		70354,
		9,
		354
	],
	"./components/dashboard/portfolio/IpoAnnouncementComponent": [
		14952,
		9,
		4952
	],
	"./components/dashboard/portfolio/IpoAnnouncementComponent.vue": [
		14952,
		9,
		4952
	],
	"./components/dashboard/portfolio/PortfolioCardComponent": [
		51512,
		9,
		1512
	],
	"./components/dashboard/portfolio/PortfolioCardComponent.vue": [
		51512,
		9,
		1512
	],
	"./components/dashboard/portfolio/PortfolioCreateButtonComponent": [
		51180,
		9,
		1180
	],
	"./components/dashboard/portfolio/PortfolioCreateButtonComponent.vue": [
		51180,
		9,
		1180
	],
	"./components/dashboard/portfolio/PortfolioFeesComponent": [
		34597,
		9,
		4597
	],
	"./components/dashboard/portfolio/PortfolioFeesComponent.vue": [
		34597,
		9,
		4597
	],
	"./components/dashboard/portfolio/PortfolioHoldings": [
		61977,
		9,
		1977
	],
	"./components/dashboard/portfolio/PortfolioHoldings.vue": [
		61977,
		9,
		1977
	],
	"./components/dashboard/portfolio/PortfolioInformation": [
		5421,
		9,
		5421
	],
	"./components/dashboard/portfolio/PortfolioInformation.vue": [
		5421,
		9,
		5421
	],
	"./components/dashboard/portfolio/PortfolioRequests": [
		64911,
		9,
		4911
	],
	"./components/dashboard/portfolio/PortfolioRequests.vue": [
		64911,
		9,
		4911
	],
	"./components/dashboard/portfolio/PortfolioTransactions": [
		90122,
		9,
		122
	],
	"./components/dashboard/portfolio/PortfolioTransactions.vue": [
		90122,
		9,
		122
	],
	"./components/dashboard/portfolio/TransferFundsModal": [
		29403,
		9,
		9403
	],
	"./components/dashboard/portfolio/TransferFundsModal.vue": [
		29403,
		9,
		9403
	],
	"./components/dashboard/portfolio/ViewPortfolioRequest": [
		66518,
		9,
		6518
	],
	"./components/dashboard/portfolio/ViewPortfolioRequest.vue": [
		66518,
		9,
		6518
	],
	"./components/dashboard/portfolio/ViewPortfolioTransaction": [
		15761,
		9,
		5761
	],
	"./components/dashboard/portfolio/ViewPortfolioTransaction.vue": [
		15761,
		9,
		5761
	],
	"./components/dashboard/profile/CityPickerComponent": [
		69733,
		9,
		9733
	],
	"./components/dashboard/profile/CityPickerComponent.vue": [
		69733,
		9,
		9733
	],
	"./components/dashboard/profile/CountryPickerComponent": [
		43803,
		9,
		3803
	],
	"./components/dashboard/profile/CountryPickerComponent.vue": [
		43803,
		9,
		3803
	],
	"./components/dashboard/profile/MobileMoneyComponent": [
		43945,
		9,
		3945
	],
	"./components/dashboard/profile/MobileMoneyComponent.vue": [
		43945,
		9,
		3945
	],
	"./components/dashboard/profile/PhoneNumberComponent": [
		69037,
		9,
		9037
	],
	"./components/dashboard/profile/PhoneNumberComponent.vue": [
		69037,
		9,
		9037
	],
	"./components/dashboard/profile/PoliticalExposedPersonModal": [
		20110,
		9,
		110
	],
	"./components/dashboard/profile/PoliticalExposedPersonModal.vue": [
		20110,
		9,
		110
	],
	"./components/dashboard/profile/RequestProfileUpdateComponent": [
		71895,
		9,
		1895
	],
	"./components/dashboard/profile/RequestProfileUpdateComponent.vue": [
		71895,
		9,
		1895
	],
	"./components/dashboard/profile/ShowProfileModal": [
		62412,
		9,
		2412
	],
	"./components/dashboard/profile/ShowProfileModal.vue": [
		62412,
		9,
		2412
	],
	"./components/dashboard/profile/UpdateFinancialInformationModal": [
		18652,
		9,
		5062
	],
	"./components/dashboard/profile/UpdateFinancialInformationModal.vue": [
		18652,
		9,
		5062
	],
	"./components/dashboard/profile/UpdatePersonalInformationModal": [
		87773,
		9,
		7773
	],
	"./components/dashboard/profile/UpdatePersonalInformationModal.vue": [
		87773,
		9,
		7773
	],
	"./components/dashboard/profile/UpdateProfessionInformationModal": [
		98562,
		9,
		8562
	],
	"./components/dashboard/profile/UpdateProfessionInformationModal.vue": [
		98562,
		9,
		8562
	],
	"./components/dashboard/profile/UsResidentForTaxModal": [
		20228,
		9,
		228
	],
	"./components/dashboard/profile/UsResidentForTaxModal.vue": [
		20228,
		9,
		228
	],
	"./components/dashboard/profile/ViewSourceOfFundsModal": [
		51037,
		9,
		1037
	],
	"./components/dashboard/profile/ViewSourceOfFundsModal.vue": [
		51037,
		9,
		1037
	],
	"./components/dashboard/requests/DepositFormComponent": [
		77475,
		9,
		7475
	],
	"./components/dashboard/requests/DepositFormComponent.vue": [
		77475,
		9,
		7475
	],
	"./components/dashboard/requests/QuickTopupAuthenticationComponent": [
		68848,
		9,
		8848
	],
	"./components/dashboard/requests/QuickTopupAuthenticationComponent.vue": [
		68848,
		9,
		8848
	],
	"./components/dashboard/requests/QuickTopupComponent": [
		5125,
		9,
		5125
	],
	"./components/dashboard/requests/QuickTopupComponent.vue": [
		5125,
		9,
		5125
	],
	"./components/dashboard/requests/QuickTopupPaymentComponent": [
		54516,
		9,
		4516
	],
	"./components/dashboard/requests/QuickTopupPaymentComponent.vue": [
		54516,
		9,
		4516
	],
	"./components/dashboard/requests/RequestSummaryComponent": [
		93356,
		9,
		3356
	],
	"./components/dashboard/requests/RequestSummaryComponent.vue": [
		93356,
		9,
		3356
	],
	"./components/dashboard/requests/statements/StatementAccountPortfolioComponent": [
		46234,
		9,
		6234
	],
	"./components/dashboard/requests/statements/StatementAccountPortfolioComponent.vue": [
		46234,
		9,
		6234
	],
	"./components/dashboard/requests/statements/StatementTransactionHistoryComponent": [
		78282,
		9,
		8282
	],
	"./components/dashboard/requests/statements/StatementTransactionHistoryComponent.vue": [
		78282,
		9,
		8282
	],
	"./components/dashboard/trade/EquitiesMarketInformationComponent": [
		7662,
		9,
		7662
	],
	"./components/dashboard/trade/EquitiesMarketInformationComponent.vue": [
		7662,
		9,
		7662
	],
	"./components/dashboard/trade/FixedIncomeMarketInformationComponent": [
		51632,
		9,
		1632
	],
	"./components/dashboard/trade/FixedIncomeMarketInformationComponent.vue": [
		51632,
		9,
		1632
	],
	"./components/dashboard/trade/Modals/IclfTopUpModal": [
		79063,
		9,
		9063
	],
	"./components/dashboard/trade/Modals/IclfTopUpModal.vue": [
		79063,
		9,
		9063
	],
	"./components/dashboard/trade/TradeCashBalanceComponent": [
		46977,
		9,
		6977
	],
	"./components/dashboard/trade/TradeCashBalanceComponent.vue": [
		46977,
		9,
		6977
	],
	"./components/dashboard/trade/TradeSummaryComponent": [
		81629,
		9,
		1629
	],
	"./components/dashboard/trade/TradeSummaryComponent.vue": [
		81629,
		9,
		1629
	],
	"./components/dashboard/transactions/FeeInformation": [
		41107,
		9,
		1107
	],
	"./components/dashboard/transactions/FeeInformation.vue": [
		41107,
		9,
		1107
	],
	"./components/dashboard/transactions/ReportTransactionModal": [
		14487,
		9,
		4487
	],
	"./components/dashboard/transactions/ReportTransactionModal.vue": [
		14487,
		9,
		4487
	],
	"./components/dashboard/transactions/RequestInformation": [
		94605,
		9,
		4605
	],
	"./components/dashboard/transactions/RequestInformation.vue": [
		94605,
		9,
		4605
	],
	"./components/dashboard/transactions/TransactionDefinitionModal": [
		51198,
		9,
		1198
	],
	"./components/dashboard/transactions/TransactionDefinitionModal.vue": [
		51198,
		9,
		1198
	],
	"./components/dashboard/transactions/TransactionInformation": [
		26485,
		9,
		6485
	],
	"./components/dashboard/transactions/TransactionInformation.vue": [
		26485,
		9,
		6485
	],
	"./components/dashboard/transactions/TransactionsTableComponent": [
		18964,
		9,
		8964
	],
	"./components/dashboard/transactions/TransactionsTableComponent.vue": [
		18964,
		9,
		8964
	],
	"./components/landing/AccordionComponent": [
		3249,
		9,
		3249
	],
	"./components/landing/AccordionComponent.vue": [
		3249,
		9,
		3249
	],
	"./components/landing/ContactUsComponent": [
		96500,
		9,
		6500
	],
	"./components/landing/ContactUsComponent.vue": [
		96500,
		9,
		6500
	],
	"./components/landing/FaqsComponent": [
		94776,
		9,
		4776
	],
	"./components/landing/FaqsComponent.vue": [
		94776,
		9,
		4776
	],
	"./components/landing/SpeakToExpertComponent": [
		88910,
		9,
		8910
	],
	"./components/landing/SpeakToExpertComponent.vue": [
		88910,
		9,
		8910
	],
	"./components/security/Csrf": [
		85157,
		9,
		5157
	],
	"./components/security/Csrf.vue": [
		85157,
		9,
		5157
	],
	"./components/ui/BreadcrumbsComponent": [
		54143,
		9,
		4143
	],
	"./components/ui/BreadcrumbsComponent.vue": [
		54143,
		9,
		4143
	],
	"./components/ui/ButtonComponent": [
		42696,
		9,
		2696
	],
	"./components/ui/ButtonComponent.vue": [
		42696,
		9,
		2696
	],
	"./components/ui/DropzoneComponent": [
		80189,
		9,
		189
	],
	"./components/ui/DropzoneComponent.vue": [
		80189,
		9,
		189
	],
	"./components/ui/FeatureAnnouncementModal": [
		16147,
		9,
		6147
	],
	"./components/ui/FeatureAnnouncementModal.vue": [
		16147,
		9,
		6147
	],
	"./components/ui/LoaderComponent": [
		35335,
		9,
		5335
	],
	"./components/ui/LoaderComponent.vue": [
		35335,
		9,
		5335
	],
	"./components/ui/MultiAttrTipComponent": [
		52941,
		9,
		2941
	],
	"./components/ui/MultiAttrTipComponent.vue": [
		52941,
		9,
		2941
	],
	"./components/ui/ProcessComponent": [
		29642,
		9,
		9642
	],
	"./components/ui/ProcessComponent.vue": [
		29642,
		9,
		9642
	],
	"./components/ui/SpinnerComponent": [
		83474,
		9,
		3474
	],
	"./components/ui/SpinnerComponent.vue": [
		83474,
		9,
		3474
	],
	"./components/ui/SubAccountBreadCrumbsComponent": [
		8349,
		9,
		8349
	],
	"./components/ui/SubAccountBreadCrumbsComponent.vue": [
		8349,
		9,
		8349
	],
	"./components/ui/navbar/SubAccountNav": [
		59263,
		9,
		9263
	],
	"./components/ui/navbar/SubAccountNav.vue": [
		59263,
		9,
		9263
	],
	"./directives": [
		43584,
		9
	],
	"./directives/": [
		43584,
		9
	],
	"./directives/index": [
		43584,
		9
	],
	"./directives/index.js": [
		43584,
		9
	],
	"./filters": [
		24526,
		9
	],
	"./filters/": [
		24526,
		9
	],
	"./filters/index": [
		24526,
		9
	],
	"./filters/index.js": [
		24526,
		9
	],
	"./mixins": [
		14810,
		9
	],
	"./mixins/": [
		14810,
		9
	],
	"./mixins/authentication": [
		95538,
		9
	],
	"./mixins/authentication.js": [
		95538,
		9
	],
	"./mixins/index": [
		14810,
		9
	],
	"./mixins/index.js": [
		14810,
		9
	],
	"./mixins/portfolio": [
		62217,
		9
	],
	"./mixins/portfolio.js": [
		62217,
		9
	],
	"./mixins/requests": [
		1852,
		9
	],
	"./mixins/requests/": [
		1852,
		9
	],
	"./mixins/requests/index": [
		1852,
		9
	],
	"./mixins/requests/index.js": [
		1852,
		9
	],
	"./mixins/requests/requests": [
		3864,
		9
	],
	"./mixins/requests/requests.js": [
		3864,
		9
	],
	"./mixins/requests/transactions": [
		62043,
		9
	],
	"./mixins/requests/transactions.js": [
		62043,
		9
	],
	"./mixins/trade": [
		93262,
		9
	],
	"./mixins/trade/": [
		93262,
		9
	],
	"./mixins/trade/equities": [
		41149,
		9
	],
	"./mixins/trade/equities.js": [
		41149,
		9
	],
	"./mixins/trade/fixed-income": [
		36162,
		9
	],
	"./mixins/trade/fixed-income.js": [
		36162,
		9
	],
	"./mixins/trade/index": [
		93262,
		9
	],
	"./mixins/trade/index.js": [
		93262,
		9
	],
	"./mixins/validations": [
		82174,
		9
	],
	"./mixins/validations/": [
		82174,
		9
	],
	"./mixins/validations/index": [
		82174,
		9
	],
	"./mixins/validations/index.js": [
		82174,
		9
	],
	"./mixins/validations/newClientValidation": [
		85684,
		9
	],
	"./mixins/validations/newClientValidation.js": [
		85684,
		9
	],
	"./router": [
		82997,
		9
	],
	"./router/": [
		82997,
		9
	],
	"./router/index": [
		82997,
		9
	],
	"./router/index.js": [
		82997,
		9
	],
	"./router/routes": [
		73521,
		9
	],
	"./router/routes/": [
		73521,
		9
	],
	"./router/routes/auth": [
		67066,
		9
	],
	"./router/routes/auth/": [
		67066,
		9
	],
	"./router/routes/auth/index": [
		67066,
		9
	],
	"./router/routes/auth/index.js": [
		67066,
		9
	],
	"./router/routes/auth/passwords": [
		15213,
		9
	],
	"./router/routes/auth/passwords.js": [
		15213,
		9
	],
	"./router/routes/dashboard": [
		15351,
		9
	],
	"./router/routes/dashboard/": [
		15351,
		9
	],
	"./router/routes/dashboard/dashboard": [
		16495,
		9
	],
	"./router/routes/dashboard/dashboard.js": [
		16495,
		9
	],
	"./router/routes/dashboard/index": [
		15351,
		9
	],
	"./router/routes/dashboard/index.js": [
		15351,
		9
	],
	"./router/routes/dashboard/portfolio": [
		18363,
		9
	],
	"./router/routes/dashboard/portfolio/": [
		18363,
		9
	],
	"./router/routes/dashboard/portfolio/index": [
		18363,
		9
	],
	"./router/routes/dashboard/portfolio/index.js": [
		18363,
		9
	],
	"./router/routes/dashboard/prices": [
		98663,
		9
	],
	"./router/routes/dashboard/prices.js": [
		98663,
		9
	],
	"./router/routes/dashboard/profile": [
		52524,
		9
	],
	"./router/routes/dashboard/profile.js": [
		52524,
		9
	],
	"./router/routes/dashboard/requests": [
		95993,
		9
	],
	"./router/routes/dashboard/requests.js": [
		95993,
		9
	],
	"./router/routes/dashboard/setgoal": [
		14554,
		9
	],
	"./router/routes/dashboard/setgoal.js": [
		14554,
		9
	],
	"./router/routes/dashboard/trade": [
		8441,
		9
	],
	"./router/routes/dashboard/trade.js": [
		8441,
		9
	],
	"./router/routes/index": [
		73521,
		9
	],
	"./router/routes/index.js": [
		73521,
		9
	],
	"./scripts": [
		42499,
		9,
		2499
	],
	"./scripts/": [
		42499,
		9,
		2499
	],
	"./scripts/index": [
		42499,
		9,
		2499
	],
	"./scripts/index.js": [
		42499,
		9,
		2499
	],
	"./scripts/mail": [
		74372,
		9,
		4372
	],
	"./scripts/mail.js": [
		74372,
		9,
		4372
	],
	"./store": [
		77690,
		9
	],
	"./store/": [
		77690,
		9
	],
	"./store/actions": [
		39649,
		9
	],
	"./store/actions.js": [
		39649,
		9
	],
	"./store/getters": [
		18141,
		9
	],
	"./store/getters.js": [
		18141,
		9
	],
	"./store/index": [
		77690,
		9
	],
	"./store/index.js": [
		77690,
		9
	],
	"./store/json/badge_style": [
		70543,
		3
	],
	"./store/json/badge_style.json": [
		70543,
		3
	],
	"./store/json/bank_account_types": [
		97602,
		3
	],
	"./store/json/bank_account_types.json": [
		97602,
		3
	],
	"./store/json/beneficial_owner": [
		63546,
		3
	],
	"./store/json/beneficial_owner.json": [
		63546,
		3
	],
	"./store/json/contact_subjects": [
		78658,
		3
	],
	"./store/json/contact_subjects.json": [
		78658,
		3
	],
	"./store/json/currencies": [
		5002,
		3
	],
	"./store/json/currencies.json": [
		5002,
		3
	],
	"./store/json/currencies_locale": [
		44719,
		3
	],
	"./store/json/currencies_locale.json": [
		44719,
		3
	],
	"./store/json/document_types": [
		39439,
		3
	],
	"./store/json/document_types.json": [
		39439,
		3
	],
	"./store/json/employment_types": [
		78148,
		3
	],
	"./store/json/employment_types.json": [
		78148,
		3
	],
	"./store/json/fee_statuses": [
		32927,
		3
	],
	"./store/json/fee_statuses.json": [
		32927,
		3
	],
	"./store/json/icmywealth": [
		60225,
		3
	],
	"./store/json/icmywealth.json": [
		60225,
		3
	],
	"./store/json/identification_types": [
		83494,
		3
	],
	"./store/json/identification_types.json": [
		83494,
		3
	],
	"./store/json/maturity_types": [
		3321,
		3
	],
	"./store/json/maturity_types.json": [
		3321,
		3
	],
	"./store/json/message_subjects": [
		81705,
		3
	],
	"./store/json/message_subjects.json": [
		81705,
		3
	],
	"./store/json/message_topics": [
		73187,
		3
	],
	"./store/json/message_topics.json": [
		73187,
		3
	],
	"./store/json/month_days": [
		42298,
		3
	],
	"./store/json/month_days.json": [
		42298,
		3
	],
	"./store/json/notification_types": [
		89536,
		3
	],
	"./store/json/notification_types.json": [
		89536,
		3
	],
	"./store/json/onboarding": [
		9171,
		3,
		9171
	],
	"./store/json/onboarding.json": [
		9171,
		3,
		9171
	],
	"./store/json/order_types": [
		74191,
		3
	],
	"./store/json/order_types.json": [
		74191,
		3
	],
	"./store/json/payment_services": [
		20567,
		3
	],
	"./store/json/payment_services.json": [
		20567,
		3
	],
	"./store/json/payment_types": [
		3580,
		3
	],
	"./store/json/payment_types.json": [
		3580,
		3
	],
	"./store/json/plans": [
		42203,
		3
	],
	"./store/json/plans.json": [
		42203,
		3
	],
	"./store/json/residency_status": [
		89146,
		3
	],
	"./store/json/residency_status.json": [
		89146,
		3
	],
	"./store/json/salutations": [
		75196,
		3
	],
	"./store/json/salutations.json": [
		75196,
		3
	],
	"./store/json/stock_images": [
		75708,
		3
	],
	"./store/json/stock_images.json": [
		75708,
		3
	],
	"./store/json/transaction_types": [
		12798,
		3
	],
	"./store/json/transaction_types.json": [
		12798,
		3
	],
	"./store/modules": [
		27101,
		9
	],
	"./store/modules/": [
		27101,
		9
	],
	"./store/modules/assets": [
		12218,
		9
	],
	"./store/modules/assets/": [
		12218,
		9
	],
	"./store/modules/assets/actions": [
		82802,
		9
	],
	"./store/modules/assets/actions.js": [
		82802,
		9
	],
	"./store/modules/assets/getters": [
		98215,
		9
	],
	"./store/modules/assets/getters.js": [
		98215,
		9
	],
	"./store/modules/assets/index": [
		12218,
		9
	],
	"./store/modules/assets/index.js": [
		12218,
		9
	],
	"./store/modules/assets/mutations": [
		92323,
		9
	],
	"./store/modules/assets/mutations.js": [
		92323,
		9
	],
	"./store/modules/assets/state": [
		16679,
		9
	],
	"./store/modules/assets/state.js": [
		16679,
		9
	],
	"./store/modules/authentication": [
		6207,
		9
	],
	"./store/modules/authentication/": [
		6207,
		9
	],
	"./store/modules/authentication/actions": [
		85078,
		9
	],
	"./store/modules/authentication/actions.js": [
		85078,
		9
	],
	"./store/modules/authentication/getters": [
		13310,
		9
	],
	"./store/modules/authentication/getters.js": [
		13310,
		9
	],
	"./store/modules/authentication/index": [
		6207,
		9
	],
	"./store/modules/authentication/index.js": [
		6207,
		9
	],
	"./store/modules/authentication/mutations": [
		12887,
		9
	],
	"./store/modules/authentication/mutations.js": [
		12887,
		9
	],
	"./store/modules/authentication/state": [
		6022,
		9
	],
	"./store/modules/authentication/state.js": [
		6022,
		9
	],
	"./store/modules/banks": [
		81799,
		9
	],
	"./store/modules/banks/": [
		81799,
		9
	],
	"./store/modules/banks/actions": [
		72115,
		9
	],
	"./store/modules/banks/actions.js": [
		72115,
		9
	],
	"./store/modules/banks/getters": [
		54331,
		9
	],
	"./store/modules/banks/getters.js": [
		54331,
		9
	],
	"./store/modules/banks/index": [
		81799,
		9
	],
	"./store/modules/banks/index.js": [
		81799,
		9
	],
	"./store/modules/banks/mutations": [
		20549,
		9
	],
	"./store/modules/banks/mutations.js": [
		20549,
		9
	],
	"./store/modules/banks/state": [
		10612,
		9
	],
	"./store/modules/banks/state.js": [
		10612,
		9
	],
	"./store/modules/clients": [
		86255,
		9
	],
	"./store/modules/clients/": [
		86255,
		9
	],
	"./store/modules/clients/actions": [
		71628,
		9
	],
	"./store/modules/clients/actions.js": [
		71628,
		9
	],
	"./store/modules/clients/getters": [
		16820,
		9
	],
	"./store/modules/clients/getters.js": [
		16820,
		9
	],
	"./store/modules/clients/index": [
		86255,
		9
	],
	"./store/modules/clients/index.js": [
		86255,
		9
	],
	"./store/modules/clients/mutations": [
		4195,
		9
	],
	"./store/modules/clients/mutations.js": [
		4195,
		9
	],
	"./store/modules/clients/state": [
		22815,
		9
	],
	"./store/modules/clients/state.js": [
		22815,
		9
	],
	"./store/modules/dailyPrices": [
		43563,
		9
	],
	"./store/modules/dailyPrices/": [
		43563,
		9
	],
	"./store/modules/dailyPrices/actions": [
		26616,
		9
	],
	"./store/modules/dailyPrices/actions.js": [
		26616,
		9
	],
	"./store/modules/dailyPrices/getters": [
		43115,
		9
	],
	"./store/modules/dailyPrices/getters.js": [
		43115,
		9
	],
	"./store/modules/dailyPrices/index": [
		43563,
		9
	],
	"./store/modules/dailyPrices/index.js": [
		43563,
		9
	],
	"./store/modules/dailyPrices/mutations": [
		50991,
		9
	],
	"./store/modules/dailyPrices/mutations.js": [
		50991,
		9
	],
	"./store/modules/dailyPrices/state": [
		48461,
		9
	],
	"./store/modules/dailyPrices/state.js": [
		48461,
		9
	],
	"./store/modules/documents": [
		61555,
		9
	],
	"./store/modules/documents/": [
		61555,
		9
	],
	"./store/modules/documents/actions": [
		20519,
		9
	],
	"./store/modules/documents/actions.js": [
		20519,
		9
	],
	"./store/modules/documents/getters": [
		82600,
		9
	],
	"./store/modules/documents/getters.js": [
		82600,
		9
	],
	"./store/modules/documents/index": [
		61555,
		9
	],
	"./store/modules/documents/index.js": [
		61555,
		9
	],
	"./store/modules/documents/mutations": [
		94758,
		9
	],
	"./store/modules/documents/mutations.js": [
		94758,
		9
	],
	"./store/modules/documents/state": [
		95878,
		9
	],
	"./store/modules/documents/state.js": [
		95878,
		9
	],
	"./store/modules/featureFlags": [
		73685,
		9
	],
	"./store/modules/featureFlags/": [
		73685,
		9
	],
	"./store/modules/featureFlags/actions": [
		50437,
		9
	],
	"./store/modules/featureFlags/actions.js": [
		50437,
		9
	],
	"./store/modules/featureFlags/getters": [
		60020,
		9
	],
	"./store/modules/featureFlags/getters.js": [
		60020,
		9
	],
	"./store/modules/featureFlags/index": [
		73685,
		9
	],
	"./store/modules/featureFlags/index.js": [
		73685,
		9
	],
	"./store/modules/featureFlags/mutations": [
		40230,
		9
	],
	"./store/modules/featureFlags/mutations.js": [
		40230,
		9
	],
	"./store/modules/featureFlags/state": [
		31546,
		9
	],
	"./store/modules/featureFlags/state.js": [
		31546,
		9
	],
	"./store/modules/fees": [
		95448,
		9
	],
	"./store/modules/fees/": [
		95448,
		9
	],
	"./store/modules/fees/actions": [
		42265,
		9
	],
	"./store/modules/fees/actions.js": [
		42265,
		9
	],
	"./store/modules/fees/getters": [
		61358,
		9
	],
	"./store/modules/fees/getters.js": [
		61358,
		9
	],
	"./store/modules/fees/index": [
		95448,
		9
	],
	"./store/modules/fees/index.js": [
		95448,
		9
	],
	"./store/modules/fees/mutations": [
		64067,
		9
	],
	"./store/modules/fees/mutations.js": [
		64067,
		9
	],
	"./store/modules/fees/state": [
		35891,
		9
	],
	"./store/modules/fees/state.js": [
		35891,
		9
	],
	"./store/modules/fxRates": [
		35125,
		9
	],
	"./store/modules/fxRates/": [
		35125,
		9
	],
	"./store/modules/fxRates/actions": [
		26393,
		9
	],
	"./store/modules/fxRates/actions.js": [
		26393,
		9
	],
	"./store/modules/fxRates/getters": [
		94740,
		9
	],
	"./store/modules/fxRates/getters.js": [
		94740,
		9
	],
	"./store/modules/fxRates/index": [
		35125,
		9
	],
	"./store/modules/fxRates/index.js": [
		35125,
		9
	],
	"./store/modules/fxRates/mutations": [
		83274,
		9
	],
	"./store/modules/fxRates/mutations.js": [
		83274,
		9
	],
	"./store/modules/fxRates/state": [
		16907,
		9
	],
	"./store/modules/fxRates/state.js": [
		16907,
		9
	],
	"./store/modules/holdings": [
		63074,
		9
	],
	"./store/modules/holdings/": [
		63074,
		9
	],
	"./store/modules/holdings/actions": [
		89180,
		9
	],
	"./store/modules/holdings/actions.js": [
		89180,
		9
	],
	"./store/modules/holdings/getters": [
		63248,
		9
	],
	"./store/modules/holdings/getters.js": [
		63248,
		9
	],
	"./store/modules/holdings/index": [
		63074,
		9
	],
	"./store/modules/holdings/index.js": [
		63074,
		9
	],
	"./store/modules/holdings/mutations": [
		72549,
		9
	],
	"./store/modules/holdings/mutations.js": [
		72549,
		9
	],
	"./store/modules/holdings/state": [
		79839,
		9
	],
	"./store/modules/holdings/state.js": [
		79839,
		9
	],
	"./store/modules/index": [
		27101,
		9
	],
	"./store/modules/index.js": [
		27101,
		9
	],
	"./store/modules/messages": [
		68131,
		9
	],
	"./store/modules/messages/": [
		68131,
		9
	],
	"./store/modules/messages/actions": [
		77868,
		9
	],
	"./store/modules/messages/actions.js": [
		77868,
		9
	],
	"./store/modules/messages/getters": [
		14396,
		9
	],
	"./store/modules/messages/getters.js": [
		14396,
		9
	],
	"./store/modules/messages/index": [
		68131,
		9
	],
	"./store/modules/messages/index.js": [
		68131,
		9
	],
	"./store/modules/messages/mutations": [
		89509,
		9
	],
	"./store/modules/messages/mutations.js": [
		89509,
		9
	],
	"./store/modules/messages/state": [
		92964,
		9
	],
	"./store/modules/messages/state.js": [
		92964,
		9
	],
	"./store/modules/portfolio": [
		12104,
		9
	],
	"./store/modules/portfolio/": [
		12104,
		9
	],
	"./store/modules/portfolio/actions": [
		87606,
		9
	],
	"./store/modules/portfolio/actions.js": [
		87606,
		9
	],
	"./store/modules/portfolio/getters": [
		48888,
		9
	],
	"./store/modules/portfolio/getters.js": [
		48888,
		9
	],
	"./store/modules/portfolio/index": [
		12104,
		9
	],
	"./store/modules/portfolio/index.js": [
		12104,
		9
	],
	"./store/modules/portfolio/mutations": [
		76539,
		9
	],
	"./store/modules/portfolio/mutations.js": [
		76539,
		9
	],
	"./store/modules/portfolio/state": [
		19682,
		9
	],
	"./store/modules/portfolio/state.js": [
		19682,
		9
	],
	"./store/modules/profile": [
		89566,
		9
	],
	"./store/modules/profile/": [
		89566,
		9
	],
	"./store/modules/profile/actions": [
		57833,
		9
	],
	"./store/modules/profile/actions.js": [
		57833,
		9
	],
	"./store/modules/profile/getters": [
		10561,
		9
	],
	"./store/modules/profile/getters.js": [
		10561,
		9
	],
	"./store/modules/profile/index": [
		89566,
		9
	],
	"./store/modules/profile/index.js": [
		89566,
		9
	],
	"./store/modules/profile/mutations": [
		60669,
		9
	],
	"./store/modules/profile/mutations.js": [
		60669,
		9
	],
	"./store/modules/profile/state": [
		33017,
		9
	],
	"./store/modules/profile/state.js": [
		33017,
		9
	],
	"./store/modules/requests": [
		5399,
		9
	],
	"./store/modules/requests/": [
		5399,
		9
	],
	"./store/modules/requests/actions": [
		48486,
		9
	],
	"./store/modules/requests/actions.js": [
		48486,
		9
	],
	"./store/modules/requests/getters": [
		52446,
		9
	],
	"./store/modules/requests/getters.js": [
		52446,
		9
	],
	"./store/modules/requests/index": [
		5399,
		9
	],
	"./store/modules/requests/index.js": [
		5399,
		9
	],
	"./store/modules/requests/mutations": [
		50201,
		9
	],
	"./store/modules/requests/mutations.js": [
		50201,
		9
	],
	"./store/modules/requests/state": [
		82257,
		9
	],
	"./store/modules/requests/state.js": [
		82257,
		9
	],
	"./store/modules/settings": [
		68463,
		9
	],
	"./store/modules/settings/": [
		68463,
		9
	],
	"./store/modules/settings/actions": [
		78734,
		9
	],
	"./store/modules/settings/actions.js": [
		78734,
		9
	],
	"./store/modules/settings/getters": [
		84509,
		9
	],
	"./store/modules/settings/getters.js": [
		84509,
		9
	],
	"./store/modules/settings/index": [
		68463,
		9
	],
	"./store/modules/settings/index.js": [
		68463,
		9
	],
	"./store/modules/settings/mutations": [
		85823,
		9
	],
	"./store/modules/settings/mutations.js": [
		85823,
		9
	],
	"./store/modules/settings/state": [
		61033,
		9
	],
	"./store/modules/settings/state.js": [
		61033,
		9
	],
	"./store/modules/trade": [
		46734,
		9
	],
	"./store/modules/trade/": [
		46734,
		9
	],
	"./store/modules/trade/actions": [
		89291,
		9
	],
	"./store/modules/trade/actions.js": [
		89291,
		9
	],
	"./store/modules/trade/getters": [
		86408,
		9
	],
	"./store/modules/trade/getters.js": [
		86408,
		9
	],
	"./store/modules/trade/index": [
		46734,
		9
	],
	"./store/modules/trade/index.js": [
		46734,
		9
	],
	"./store/modules/trade/mutations": [
		62099,
		9
	],
	"./store/modules/trade/mutations.js": [
		62099,
		9
	],
	"./store/modules/trade/state": [
		30251,
		9
	],
	"./store/modules/trade/state.js": [
		30251,
		9
	],
	"./store/modules/transactions": [
		39636,
		9
	],
	"./store/modules/transactions/": [
		39636,
		9
	],
	"./store/modules/transactions/actions": [
		49862,
		9
	],
	"./store/modules/transactions/actions.js": [
		49862,
		9
	],
	"./store/modules/transactions/getters": [
		20011,
		9
	],
	"./store/modules/transactions/getters.js": [
		20011,
		9
	],
	"./store/modules/transactions/index": [
		39636,
		9
	],
	"./store/modules/transactions/index.js": [
		39636,
		9
	],
	"./store/modules/transactions/mutations": [
		73424,
		9
	],
	"./store/modules/transactions/mutations.js": [
		73424,
		9
	],
	"./store/modules/transactions/state": [
		83611,
		9
	],
	"./store/modules/transactions/state.js": [
		83611,
		9
	],
	"./store/mutations": [
		65128,
		9
	],
	"./store/mutations.js": [
		65128,
		9
	],
	"./store/state": [
		93872,
		9
	],
	"./store/state.js": [
		93872,
		9
	],
	"./store/subscriber": [
		40665,
		9
	],
	"./store/subscriber/": [
		40665,
		9
	],
	"./store/subscriber/app": [
		54882,
		9
	],
	"./store/subscriber/app.js": [
		54882,
		9
	],
	"./store/subscriber/assets": [
		96057,
		9
	],
	"./store/subscriber/assets.js": [
		96057,
		9
	],
	"./store/subscriber/authentication": [
		87074,
		9
	],
	"./store/subscriber/authentication.js": [
		87074,
		9
	],
	"./store/subscriber/clients": [
		27661,
		9
	],
	"./store/subscriber/clients.js": [
		27661,
		9
	],
	"./store/subscriber/dailyPrices": [
		46661,
		9
	],
	"./store/subscriber/dailyPrices.js": [
		46661,
		9
	],
	"./store/subscriber/documents": [
		39924,
		9
	],
	"./store/subscriber/documents.js": [
		39924,
		9
	],
	"./store/subscriber/fees": [
		61406,
		9
	],
	"./store/subscriber/fees.js": [
		61406,
		9
	],
	"./store/subscriber/fxRates": [
		43727,
		9
	],
	"./store/subscriber/fxRates.js": [
		43727,
		9
	],
	"./store/subscriber/holdings": [
		51358,
		9
	],
	"./store/subscriber/holdings.js": [
		51358,
		9
	],
	"./store/subscriber/index": [
		40665,
		9
	],
	"./store/subscriber/index.js": [
		40665,
		9
	],
	"./store/subscriber/messages": [
		99139,
		9
	],
	"./store/subscriber/messages.js": [
		99139,
		9
	],
	"./store/subscriber/portfolio": [
		91909,
		9
	],
	"./store/subscriber/portfolio.js": [
		91909,
		9
	],
	"./store/subscriber/profile": [
		1575,
		9
	],
	"./store/subscriber/profile.js": [
		1575,
		9
	],
	"./store/subscriber/requests": [
		82873,
		9
	],
	"./store/subscriber/requests.js": [
		82873,
		9
	],
	"./store/subscriber/settings": [
		86961,
		9
	],
	"./store/subscriber/settings.js": [
		86961,
		9
	],
	"./store/subscriber/transactions": [
		77415,
		9
	],
	"./store/subscriber/transactions.js": [
		77415,
		9
	],
	"./views/dashboard/AccountComponent": [
		39270,
		9,
		9270
	],
	"./views/dashboard/AccountComponent.vue": [
		39270,
		9,
		9270
	],
	"./views/dashboard/DashboardComponent": [
		80639,
		9,
		639
	],
	"./views/dashboard/DashboardComponent.vue": [
		80639,
		9,
		639
	],
	"./views/dashboard/ProfileComponent": [
		55084,
		9,
		5084
	],
	"./views/dashboard/ProfileComponent.vue": [
		55084,
		9,
		5084
	],
	"./views/dashboard/SettingsComponent": [
		20843,
		9,
		843
	],
	"./views/dashboard/SettingsComponent.vue": [
		20843,
		9,
		843
	],
	"./views/dashboard/back-office/AssetsComponent": [
		21199,
		9,
		1199
	],
	"./views/dashboard/back-office/AssetsComponent.vue": [
		21199,
		9,
		1199
	],
	"./views/dashboard/back-office/ClientsComponent": [
		7958,
		9,
		7958
	],
	"./views/dashboard/back-office/ClientsComponent.vue": [
		7958,
		9,
		7958
	],
	"./views/dashboard/back-office/DashboardComponent": [
		16908,
		9,
		6908
	],
	"./views/dashboard/back-office/DashboardComponent.vue": [
		16908,
		9,
		6908
	],
	"./views/dashboard/back-office/DocumentsComponent": [
		47028,
		9,
		7028
	],
	"./views/dashboard/back-office/DocumentsComponent.vue": [
		47028,
		9,
		7028
	],
	"./views/dashboard/back-office/FeesComponent": [
		51902,
		9,
		1902
	],
	"./views/dashboard/back-office/FeesComponent.vue": [
		51902,
		9,
		1902
	],
	"./views/dashboard/back-office/FixedIncomeComponent": [
		69580,
		9,
		9580
	],
	"./views/dashboard/back-office/FixedIncomeComponent.vue": [
		69580,
		9,
		9580
	],
	"./views/dashboard/back-office/FxRatesComponent": [
		54872,
		9,
		4872
	],
	"./views/dashboard/back-office/FxRatesComponent.vue": [
		54872,
		9,
		4872
	],
	"./views/dashboard/back-office/HoldingsComponent": [
		84202,
		9,
		4202
	],
	"./views/dashboard/back-office/HoldingsComponent.vue": [
		84202,
		9,
		4202
	],
	"./views/dashboard/back-office/ManageCommandsComponent": [
		67229,
		9,
		7229
	],
	"./views/dashboard/back-office/ManageCommandsComponent.vue": [
		67229,
		9,
		7229
	],
	"./views/dashboard/back-office/ManageConfigurationComponent": [
		27454,
		9,
		7454
	],
	"./views/dashboard/back-office/ManageConfigurationComponent.vue": [
		27454,
		9,
		7454
	],
	"./views/dashboard/back-office/MessagesComponent": [
		9993,
		9,
		9993
	],
	"./views/dashboard/back-office/MessagesComponent.vue": [
		9993,
		9,
		9993
	],
	"./views/dashboard/back-office/PortfoliosComponent": [
		82691,
		9,
		2691
	],
	"./views/dashboard/back-office/PortfoliosComponent.vue": [
		82691,
		9,
		2691
	],
	"./views/dashboard/back-office/PricesComponent": [
		33949,
		9,
		3124
	],
	"./views/dashboard/back-office/PricesComponent.vue": [
		33949,
		9,
		3124
	],
	"./views/dashboard/back-office/ProfileComponent": [
		17175,
		9,
		7175
	],
	"./views/dashboard/back-office/ProfileComponent.vue": [
		17175,
		9,
		7175
	],
	"./views/dashboard/back-office/PushNotificationsComponent": [
		64043,
		9,
		4043
	],
	"./views/dashboard/back-office/PushNotificationsComponent.vue": [
		64043,
		9,
		4043
	],
	"./views/dashboard/back-office/RequestsComponent": [
		72213,
		9,
		2213
	],
	"./views/dashboard/back-office/RequestsComponent.vue": [
		72213,
		9,
		2213
	],
	"./views/dashboard/back-office/SubscriptionsComponent": [
		28387,
		9,
		8387
	],
	"./views/dashboard/back-office/SubscriptionsComponent.vue": [
		28387,
		9,
		8387
	],
	"./views/dashboard/back-office/TransactionsComponent": [
		65073,
		9,
		5073
	],
	"./views/dashboard/back-office/TransactionsComponent.vue": [
		65073,
		9,
		5073
	],
	"./views/dashboard/back-office/assets/ManageAssetsComponent": [
		26953,
		9,
		6953
	],
	"./views/dashboard/back-office/assets/ManageAssetsComponent.vue": [
		26953,
		9,
		6953
	],
	"./views/dashboard/back-office/assets/NewAssetComponent": [
		46883,
		9,
		6883
	],
	"./views/dashboard/back-office/assets/NewAssetComponent.vue": [
		46883,
		9,
		6883
	],
	"./views/dashboard/back-office/assets/ViewAssetComponent": [
		77048,
		9,
		7048
	],
	"./views/dashboard/back-office/assets/ViewAssetComponent.vue": [
		77048,
		9,
		7048
	],
	"./views/dashboard/back-office/clients/AssignClientSubAccountComponent": [
		92734,
		9,
		2734
	],
	"./views/dashboard/back-office/clients/AssignClientSubAccountComponent.vue": [
		92734,
		9,
		2734
	],
	"./views/dashboard/back-office/clients/ManageClientsComponent": [
		44243,
		9,
		8624
	],
	"./views/dashboard/back-office/clients/ManageClientsComponent.vue": [
		44243,
		9,
		8624
	],
	"./views/dashboard/back-office/clients/NewClientComponent": [
		9736,
		9,
		9736
	],
	"./views/dashboard/back-office/clients/NewClientComponent.vue": [
		9736,
		9,
		9736
	],
	"./views/dashboard/back-office/clients/UploadClientsComponent": [
		90687,
		9,
		687
	],
	"./views/dashboard/back-office/clients/UploadClientsComponent.vue": [
		90687,
		9,
		687
	],
	"./views/dashboard/back-office/clients/ViewClientComponent": [
		28136,
		9,
		8136
	],
	"./views/dashboard/back-office/clients/ViewClientComponent.vue": [
		28136,
		9,
		8136
	],
	"./views/dashboard/back-office/fees/ManageFeesComponent": [
		3125,
		9,
		3125
	],
	"./views/dashboard/back-office/fees/ManageFeesComponent.vue": [
		3125,
		9,
		3125
	],
	"./views/dashboard/back-office/fees/NewFeeComponent": [
		20095,
		9,
		95
	],
	"./views/dashboard/back-office/fees/NewFeeComponent.vue": [
		20095,
		9,
		95
	],
	"./views/dashboard/back-office/fees/UploadFeesComponent": [
		22747,
		9,
		2747
	],
	"./views/dashboard/back-office/fees/UploadFeesComponent.vue": [
		22747,
		9,
		2747
	],
	"./views/dashboard/back-office/fees/ViewFeeComponent": [
		87426,
		9,
		7426
	],
	"./views/dashboard/back-office/fees/ViewFeeComponent.vue": [
		87426,
		9,
		7426
	],
	"./views/dashboard/back-office/fixed-income/DeleteFixedIncomeModal": [
		35886,
		9,
		5886
	],
	"./views/dashboard/back-office/fixed-income/DeleteFixedIncomeModal.vue": [
		35886,
		9,
		5886
	],
	"./views/dashboard/back-office/fixed-income/ManageFixedIncomeComponent": [
		61152,
		9,
		1152
	],
	"./views/dashboard/back-office/fixed-income/ManageFixedIncomeComponent.vue": [
		61152,
		9,
		1152
	],
	"./views/dashboard/back-office/fixed-income/NewFixedIncomeComponent": [
		31097,
		9,
		1097
	],
	"./views/dashboard/back-office/fixed-income/NewFixedIncomeComponent.vue": [
		31097,
		9,
		1097
	],
	"./views/dashboard/back-office/fixed-income/UpdateFixedIncomeModal": [
		73339,
		9,
		3339
	],
	"./views/dashboard/back-office/fixed-income/UpdateFixedIncomeModal.vue": [
		73339,
		9,
		3339
	],
	"./views/dashboard/back-office/fixed-income/UploadFixedIncomeComponent": [
		31402,
		9,
		1402
	],
	"./views/dashboard/back-office/fixed-income/UploadFixedIncomeComponent.vue": [
		31402,
		9,
		1402
	],
	"./views/dashboard/back-office/fixed-income/ViewFixedIncomeComponent": [
		50837,
		9,
		20
	],
	"./views/dashboard/back-office/fixed-income/ViewFixedIncomeComponent.vue": [
		50837,
		9,
		20
	],
	"./views/dashboard/back-office/holdings/ManageHoldingsComponent": [
		84265,
		9,
		4265
	],
	"./views/dashboard/back-office/holdings/ManageHoldingsComponent.vue": [
		84265,
		9,
		4265
	],
	"./views/dashboard/back-office/holdings/NewHoldingComponent": [
		73117,
		9,
		3117
	],
	"./views/dashboard/back-office/holdings/NewHoldingComponent.vue": [
		73117,
		9,
		3117
	],
	"./views/dashboard/back-office/holdings/UploadHoldingsComponent": [
		60937,
		9,
		937
	],
	"./views/dashboard/back-office/holdings/UploadHoldingsComponent.vue": [
		60937,
		9,
		937
	],
	"./views/dashboard/back-office/holdings/ViewHoldingComponent": [
		91025,
		9,
		1025
	],
	"./views/dashboard/back-office/holdings/ViewHoldingComponent.vue": [
		91025,
		9,
		1025
	],
	"./views/dashboard/back-office/messages/BatchMessagesPushNotificationComponent": [
		25026,
		9,
		5026
	],
	"./views/dashboard/back-office/messages/BatchMessagesPushNotificationComponent.vue": [
		25026,
		9,
		5026
	],
	"./views/dashboard/back-office/messages/BatchPushNotificationComponent": [
		35213,
		9,
		5213
	],
	"./views/dashboard/back-office/messages/BatchPushNotificationComponent.vue": [
		35213,
		9,
		5213
	],
	"./views/dashboard/back-office/messages/CreateNotificationSegmentComponent": [
		70947,
		9,
		947
	],
	"./views/dashboard/back-office/messages/CreateNotificationSegmentComponent.vue": [
		70947,
		9,
		947
	],
	"./views/dashboard/back-office/messages/CreatePushNotificationComponent": [
		20074,
		9,
		74
	],
	"./views/dashboard/back-office/messages/CreatePushNotificationComponent.vue": [
		20074,
		9,
		74
	],
	"./views/dashboard/back-office/messages/DeleteNotificationSegmentComponent": [
		45049,
		9,
		5049
	],
	"./views/dashboard/back-office/messages/DeleteNotificationSegmentComponent.vue": [
		45049,
		9,
		5049
	],
	"./views/dashboard/back-office/messages/InboxComponent": [
		59795,
		9,
		9795
	],
	"./views/dashboard/back-office/messages/InboxComponent.vue": [
		59795,
		9,
		9795
	],
	"./views/dashboard/back-office/messages/NotificationDetailsComponent": [
		33147,
		9,
		3147
	],
	"./views/dashboard/back-office/messages/NotificationDetailsComponent.vue": [
		33147,
		9,
		3147
	],
	"./views/dashboard/back-office/messages/SinglePushNotificationComponent": [
		23952,
		9,
		3952
	],
	"./views/dashboard/back-office/messages/SinglePushNotificationComponent.vue": [
		23952,
		9,
		3952
	],
	"./views/dashboard/back-office/messages/ViewMessageComponent": [
		70802,
		9,
		802
	],
	"./views/dashboard/back-office/messages/ViewMessageComponent.vue": [
		70802,
		9,
		802
	],
	"./views/dashboard/back-office/portfolios/CreatePortfolioComponent": [
		95370,
		9,
		5370
	],
	"./views/dashboard/back-office/portfolios/CreatePortfolioComponent.vue": [
		95370,
		9,
		5370
	],
	"./views/dashboard/back-office/portfolios/ManagePortfoliosComponent": [
		52625,
		9,
		2625
	],
	"./views/dashboard/back-office/portfolios/ManagePortfoliosComponent.vue": [
		52625,
		9,
		2625
	],
	"./views/dashboard/back-office/portfolios/UploadPortfoliosComponent": [
		3118,
		9,
		3118
	],
	"./views/dashboard/back-office/portfolios/UploadPortfoliosComponent.vue": [
		3118,
		9,
		3118
	],
	"./views/dashboard/back-office/portfolios/ViewPortfolioComponent": [
		81453,
		9,
		1453
	],
	"./views/dashboard/back-office/portfolios/ViewPortfolioComponent.vue": [
		81453,
		9,
		1453
	],
	"./views/dashboard/back-office/prices/AttachFileComponent": [
		88770,
		9,
		8770
	],
	"./views/dashboard/back-office/prices/AttachFileComponent.vue": [
		88770,
		9,
		8770
	],
	"./views/dashboard/back-office/prices/ManagePricesComponent": [
		25765,
		9,
		5765
	],
	"./views/dashboard/back-office/prices/ManagePricesComponent.vue": [
		25765,
		9,
		5765
	],
	"./views/dashboard/back-office/prices/UploadPricesComponent": [
		97826,
		9,
		7826
	],
	"./views/dashboard/back-office/prices/UploadPricesComponent.vue": [
		97826,
		9,
		7826
	],
	"./views/dashboard/back-office/requests/ManageRequestsComponent": [
		60311,
		9,
		311
	],
	"./views/dashboard/back-office/requests/ManageRequestsComponent.vue": [
		60311,
		9,
		311
	],
	"./views/dashboard/back-office/requests/NewRequestComponent": [
		63254,
		9,
		3254
	],
	"./views/dashboard/back-office/requests/NewRequestComponent.vue": [
		63254,
		9,
		3254
	],
	"./views/dashboard/back-office/requests/ViewRequestComponent": [
		76047,
		9,
		6047
	],
	"./views/dashboard/back-office/requests/ViewRequestComponent.vue": [
		76047,
		9,
		6047
	],
	"./views/dashboard/back-office/requests/WithdrawalRequestsComponent": [
		16645,
		9,
		6645
	],
	"./views/dashboard/back-office/requests/WithdrawalRequestsComponent.vue": [
		16645,
		9,
		6645
	],
	"./views/dashboard/back-office/subscriptions/BulkUpdateSubscriptionComponent": [
		39806,
		9,
		9806
	],
	"./views/dashboard/back-office/subscriptions/BulkUpdateSubscriptionComponent.vue": [
		39806,
		9,
		9806
	],
	"./views/dashboard/back-office/subscriptions/CreateSubscriptionComponent": [
		15353,
		9,
		5353
	],
	"./views/dashboard/back-office/subscriptions/CreateSubscriptionComponent.vue": [
		15353,
		9,
		5353
	],
	"./views/dashboard/back-office/subscriptions/ManageSubscriptionsComponent": [
		54953,
		9,
		4953
	],
	"./views/dashboard/back-office/subscriptions/ManageSubscriptionsComponent.vue": [
		54953,
		9,
		4953
	],
	"./views/dashboard/back-office/subscriptions/UploadSubscriptionComponent": [
		87518,
		9,
		7518
	],
	"./views/dashboard/back-office/subscriptions/UploadSubscriptionComponent.vue": [
		87518,
		9,
		7518
	],
	"./views/dashboard/back-office/subscriptions/ViewSubscriptionComponent": [
		243,
		9,
		243
	],
	"./views/dashboard/back-office/subscriptions/ViewSubscriptionComponent.vue": [
		243,
		9,
		243
	],
	"./views/dashboard/back-office/transactions/CheckRedemptionsComponent": [
		29031,
		9,
		9031
	],
	"./views/dashboard/back-office/transactions/CheckRedemptionsComponent.vue": [
		29031,
		9,
		9031
	],
	"./views/dashboard/back-office/transactions/ManageTransactionsComponent": [
		38430,
		9,
		8430
	],
	"./views/dashboard/back-office/transactions/ManageTransactionsComponent.vue": [
		38430,
		9,
		8430
	],
	"./views/dashboard/back-office/transactions/NewTransactionComponent": [
		3720,
		9,
		3720
	],
	"./views/dashboard/back-office/transactions/NewTransactionComponent.vue": [
		3720,
		9,
		3720
	],
	"./views/dashboard/back-office/transactions/UploadTransactionsComponent": [
		78574,
		9,
		8574
	],
	"./views/dashboard/back-office/transactions/UploadTransactionsComponent.vue": [
		78574,
		9,
		8574
	],
	"./views/dashboard/back-office/transactions/ViewTransactionComponent": [
		67091,
		9,
		7091
	],
	"./views/dashboard/back-office/transactions/ViewTransactionComponent.vue": [
		67091,
		9,
		7091
	],
	"./views/dashboard/customer/ApprovalsComponent": [
		3646,
		9,
		3646
	],
	"./views/dashboard/customer/ApprovalsComponent.vue": [
		3646,
		9,
		3646
	],
	"./views/dashboard/customer/DashboardComponent": [
		66159,
		9,
		6159
	],
	"./views/dashboard/customer/DashboardComponent.vue": [
		66159,
		9,
		6159
	],
	"./views/dashboard/customer/DocumentsComponent": [
		64607,
		9,
		4607
	],
	"./views/dashboard/customer/DocumentsComponent.vue": [
		64607,
		9,
		4607
	],
	"./views/dashboard/customer/FeatureCardsComponent": [
		26255,
		9,
		6255
	],
	"./views/dashboard/customer/FeatureCardsComponent.vue": [
		26255,
		9,
		6255
	],
	"./views/dashboard/customer/FeesComponent": [
		82581,
		9,
		2581
	],
	"./views/dashboard/customer/FeesComponent.vue": [
		82581,
		9,
		2581
	],
	"./views/dashboard/customer/MessagesComponent": [
		83777,
		9,
		3777
	],
	"./views/dashboard/customer/MessagesComponent.vue": [
		83777,
		9,
		3777
	],
	"./views/dashboard/customer/PortfolioComponent": [
		21755,
		9,
		1755
	],
	"./views/dashboard/customer/PortfolioComponent.vue": [
		21755,
		9,
		1755
	],
	"./views/dashboard/customer/PricesComponent": [
		84681,
		9,
		4681
	],
	"./views/dashboard/customer/PricesComponent.vue": [
		84681,
		9,
		4681
	],
	"./views/dashboard/customer/RequestsComponent": [
		42425,
		9,
		2425
	],
	"./views/dashboard/customer/RequestsComponent.vue": [
		42425,
		9,
		2425
	],
	"./views/dashboard/customer/SetGoalComponent": [
		2296,
		9,
		2296
	],
	"./views/dashboard/customer/SetGoalComponent.vue": [
		2296,
		9,
		2296
	],
	"./views/dashboard/customer/TradeComponent": [
		14585,
		9,
		4585
	],
	"./views/dashboard/customer/TradeComponent.vue": [
		14585,
		9,
		4585
	],
	"./views/dashboard/customer/WelcomeComponent": [
		84261,
		9,
		4261
	],
	"./views/dashboard/customer/WelcomeComponent.vue": [
		84261,
		9,
		4261
	],
	"./views/dashboard/customer/analytics/PriceComparisonComponent": [
		43683,
		9,
		3683
	],
	"./views/dashboard/customer/analytics/PriceComparisonComponent.vue": [
		43683,
		9,
		3683
	],
	"./views/dashboard/customer/approvals/ApprovalList": [
		78848,
		9,
		1020
	],
	"./views/dashboard/customer/approvals/ApprovalList.vue": [
		78848,
		9,
		1020
	],
	"./views/dashboard/customer/approvals/ApprovalRequestDetails": [
		24898,
		9,
		4898
	],
	"./views/dashboard/customer/approvals/ApprovalRequestDetails.vue": [
		24898,
		9,
		4898
	],
	"./views/dashboard/customer/approvals/ManageApprovalsComponent": [
		70121,
		9,
		121
	],
	"./views/dashboard/customer/approvals/ManageApprovalsComponent.vue": [
		70121,
		9,
		121
	],
	"./views/dashboard/customer/approvals/ViewApprovalComponent": [
		82321,
		9,
		2321
	],
	"./views/dashboard/customer/approvals/ViewApprovalComponent.vue": [
		82321,
		9,
		2321
	],
	"./views/dashboard/customer/messages/InboxComponent": [
		94090,
		9,
		4090
	],
	"./views/dashboard/customer/messages/InboxComponent.vue": [
		94090,
		9,
		4090
	],
	"./views/dashboard/customer/messages/NewMessageComponent": [
		17056,
		9,
		7056
	],
	"./views/dashboard/customer/messages/NewMessageComponent.vue": [
		17056,
		9,
		7056
	],
	"./views/dashboard/customer/messages/SentComponent": [
		9685,
		9,
		9685
	],
	"./views/dashboard/customer/messages/SentComponent.vue": [
		9685,
		9,
		9685
	],
	"./views/dashboard/customer/messages/ViewMessageComponent": [
		17734,
		9,
		7734
	],
	"./views/dashboard/customer/messages/ViewMessageComponent.vue": [
		17734,
		9,
		7734
	],
	"./views/dashboard/customer/portfolio/DirectDebitComponent": [
		67494,
		9,
		7592,
		7494
	],
	"./views/dashboard/customer/portfolio/DirectDebitComponent.vue": [
		67494,
		9,
		7592,
		7494
	],
	"./views/dashboard/customer/portfolio/PortfolioDetailsComponent": [
		2953,
		9,
		2953
	],
	"./views/dashboard/customer/portfolio/PortfolioDetailsComponent.vue": [
		2953,
		9,
		2953
	],
	"./views/dashboard/customer/prices/TrendComponent": [
		25625,
		9,
		5625
	],
	"./views/dashboard/customer/prices/TrendComponent.vue": [
		25625,
		9,
		5625
	],
	"./views/dashboard/customer/profile/BankAccountInformationComponent": [
		10625,
		9,
		625
	],
	"./views/dashboard/customer/profile/BankAccountInformationComponent.vue": [
		10625,
		9,
		625
	],
	"./views/dashboard/customer/profile/FinancialInformationComponent": [
		62518,
		9,
		2518
	],
	"./views/dashboard/customer/profile/FinancialInformationComponent.vue": [
		62518,
		9,
		2518
	],
	"./views/dashboard/customer/profile/InvestmentManagementAgreementComponent": [
		3949,
		9,
		3949
	],
	"./views/dashboard/customer/profile/InvestmentManagementAgreementComponent.vue": [
		3949,
		9,
		3949
	],
	"./views/dashboard/customer/profile/PersonalInformationComponent": [
		8365,
		9,
		8365
	],
	"./views/dashboard/customer/profile/PersonalInformationComponent.vue": [
		8365,
		9,
		8365
	],
	"./views/dashboard/customer/profile/ProfessionInformationComponent": [
		87434,
		9,
		7434
	],
	"./views/dashboard/customer/profile/ProfessionInformationComponent.vue": [
		87434,
		9,
		7434
	],
	"./views/dashboard/customer/profile/RiskProfileComponent": [
		95813,
		9,
		5813
	],
	"./views/dashboard/customer/profile/RiskProfileComponent.vue": [
		95813,
		9,
		5813
	],
	"./views/dashboard/customer/requests/DepositComponent": [
		88977,
		9,
		8977
	],
	"./views/dashboard/customer/requests/DepositComponent.vue": [
		88977,
		9,
		8977
	],
	"./views/dashboard/customer/requests/StatementComponent": [
		21683,
		9,
		1683
	],
	"./views/dashboard/customer/requests/StatementComponent.vue": [
		21683,
		9,
		1683
	],
	"./views/dashboard/customer/requests/WithdrawComponent": [
		55953,
		9,
		5953
	],
	"./views/dashboard/customer/requests/WithdrawComponent.vue": [
		55953,
		9,
		5953
	],
	"./views/dashboard/customer/settings/AlertsComponent": [
		32358,
		9,
		2358
	],
	"./views/dashboard/customer/settings/AlertsComponent.vue": [
		32358,
		9,
		2358
	],
	"./views/dashboard/customer/settings/ChangePasswordComponent": [
		78841,
		9,
		8841
	],
	"./views/dashboard/customer/settings/ChangePasswordComponent.vue": [
		78841,
		9,
		8841
	],
	"./views/dashboard/customer/settings/SubAccountComponent": [
		14675,
		9,
		4675
	],
	"./views/dashboard/customer/settings/SubAccountComponent.vue": [
		14675,
		9,
		4675
	],
	"./views/dashboard/customer/settings/SubscriptionComponent": [
		64243,
		9,
		7592,
		4243
	],
	"./views/dashboard/customer/settings/SubscriptionComponent.vue": [
		64243,
		9,
		7592,
		4243
	],
	"./views/dashboard/customer/settings/subscriptions/DirectDebitTableComponent": [
		36999,
		9,
		6999
	],
	"./views/dashboard/customer/settings/subscriptions/DirectDebitTableComponent.vue": [
		36999,
		9,
		6999
	],
	"./views/dashboard/customer/settings/subscriptions/SubsriptionDetiailsComponent": [
		90722,
		9,
		722
	],
	"./views/dashboard/customer/settings/subscriptions/SubsriptionDetiailsComponent.vue": [
		90722,
		9,
		722
	],
	"./views/dashboard/customer/trade/InitializeTradeComponent": [
		44722,
		9,
		4722
	],
	"./views/dashboard/customer/trade/InitializeTradeComponent.vue": [
		44722,
		9,
		4722
	],
	"./views/dashboard/customer/trade/TradeEquitiesComponent": [
		34936,
		9,
		4936
	],
	"./views/dashboard/customer/trade/TradeEquitiesComponent.vue": [
		34936,
		9,
		4936
	],
	"./views/dashboard/customer/trade/TradeFixedIncomeComponent": [
		57398,
		9,
		7398
	],
	"./views/dashboard/customer/trade/TradeFixedIncomeComponent.vue": [
		57398,
		9,
		7398
	],
	"./views/dashboard/customer/trade/TradeHistoryComponent": [
		33200,
		9,
		3200
	],
	"./views/dashboard/customer/trade/TradeHistoryComponent.vue": [
		33200,
		9,
		3200
	],
	"./views/layout/partials/SidebarComponent": [
		19684,
		9,
		9684
	],
	"./views/layout/partials/SidebarComponent.vue": [
		19684,
		9,
		9684
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42792;
module.exports = webpackAsyncContext;